import { Tab, Nav } from "react-bootstrap";
import ProfileLatestNewsSection from "../player/profileLatestNews/profileLatestNewsSection";
import ProfileOverviewSection from "../player/profileOverview/profileOverviewSection";
import ProfileStatisticsSection from "../player/profileStatistics/profileStatisticsSection";
import ProfileVideosSection from "../player/profileVideos/profileVideosSection";
import ProfileGallerySection from "../player/profileGallery/profileGallerySection";
import {
  BASEBALL_STATISTICS,
  BASEBALL_TEAM_STATISTICS,
} from "../../constant/match";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";

export default function PlayerProfileTabView(props: any) {
  const isTeam = props?.isTeam ? true : false;
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";

  console.log("props stats >>", props);

  return (
    // redirectToNotFound ? <Redirect to='/404' />
    //   :
    <div className="player-tab-section">
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Nav bsPrefix="nav nav-tabs theme-gray" as="ul">
          <Nav.Item as="li">
            <Nav.Link
              className="theme-white bold text-capitalize"
              eventKey="first"
            >
              {isTeam
                ? BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                    "overview"
                  ]
                : BASEBALL_STATISTICS["player_profile"][selectedLang][
                    "overview"
                  ]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link
              className="theme-white bold text-capitalize"
              eventKey="second"
            >
              {isTeam
                ? BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                    "statistics"
                  ]
                : BASEBALL_STATISTICS["player_profile"][selectedLang][
                    "statistics"
                  ]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link
              className="theme-white bold text-capitalize"
              eventKey="third"
            >
              {isTeam
                ? BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                    "gallery"
                  ]
                : BASEBALL_STATISTICS["player_profile"][selectedLang][
                    "gallery"
                  ]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link
              className="theme-white bold text-capitalize"
              eventKey="fourth"
            >
              {isTeam
                ? BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                    "videos"
                  ]
                : BASEBALL_STATISTICS["player_profile"][selectedLang]["videos"]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link
              className="theme-white bold text-capitalize"
              eventKey="fiveth"
            >
              {isTeam
                ? BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                    "latest_news"
                  ]
                : BASEBALL_STATISTICS["player_profile"][selectedLang][
                    "latest_news"
                  ]}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="first" mountOnEnter={true}>
            <ProfileOverviewSection data={props?.overview} />
          </Tab.Pane>
          <Tab.Pane eventKey="second" mountOnEnter={true}>
            <ProfileStatisticsSection
              data={props?.statistics}
              isTeam={props?.isTeam}
              topperDetails={props?.topperDetails}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="third" mountOnEnter={true}>
            <ProfileGallerySection data={props?.gallery} />
          </Tab.Pane>
          <Tab.Pane eventKey="fourth" mountOnEnter={true}>
            <ProfileVideosSection data={props?.videos} />
          </Tab.Pane>
          <Tab.Pane eventKey="fiveth" mountOnEnter={true}>
            <ProfileLatestNewsSection data={props?.news} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
